import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllQuotations = createAsyncThunk(
  "CustomQuotaion/FindAllCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/FindAllCustomQuotaionStep1`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createQuotationStep1 = createAsyncThunk(
  "CustomQuotaion/InsertCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/InsertCustomQuotaionStep1`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createQuotationStep2 = createAsyncThunk(
  "CustomQuotaion/InsertCustomQuotaionStep2",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/InsertCustomQuotaionStep2`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting quotation step 2:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateQuotationStep1 = createAsyncThunk(
  "CustomQuotaion/UpdateCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/UpdateCustomQuotaionStep1`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteQuotation = createAsyncThunk(
  "CustomQuotaion/DeleteCustomQuotaionStep1",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/DeleteCustomQuotaionStep1`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getQuotationByID = createAsyncThunk(
  "CustomQuotaion/FindByIDCustomQuotaionStep1",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/FindByIDCustomQuotaionStep1`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        MobileNo: result?.MobileNo,
        EmailID: result?.EmailID,
        StartDate: result?.StartDate
          ? moment(result?.StartDate, "YYYY-MM-DD")?.toDate()
          : "",
        EndDate: result?.EndDate
          ? moment(result?.EndDate, "YYYY-MM-DD")?.toDate()
          : "",
        PickUpPlace: result?.PickUpPlace,
        PickUpDate: result?.PickUpDate
          ? moment(result?.PickUpDate, "YYYY-MM-DD")?.toDate()
          : "",
        DropPlace: result?.DropPlace,
        DropDate: result?.DropDate
          ? moment(result?.DropDate, "YYYY-MM-DD")?.toDate()
          : "",
        TotalRoom: result?.TotalRoom,
        TotalAdult: result?.TotalAdult,
        TotalCWB: result?.TotalCWB,
        TotalCNB: result?.TotalCNB,
        TotalAccommodationRate: result?.TotalAccommodationRate,
        DriverAllowance: result?.DriverAllowance,
        TotalTax: result?.TotalTax,
        TotalTransportation: result?.TotalTransportation,
        TotalMiscellaneous: result?.TotalMiscellaneous,
        Accommodations: result?.Accommodations
          ? result?.Accommodations?.map((accommodation: any) => {
              return {
                Place: accommodation?.Place ? accommodation?.Place : "",
                Hotel: accommodation?.Hotel ? accommodation?.Hotel : "",
                CheckInDate: accommodation?.CheckInDate
                  ? moment(accommodation?.CheckInDate, "YYYY-MM-DD").toDate()
                  : "",
                CheckOutDate: accommodation?.CheckOutDate
                  ? moment(accommodation?.CheckOutDate, "YYYY-MM-DD").toDate()
                  : "",
                RoomTypeID: accommodation?.RoomTypeID
                  ? +accommodation?.RoomTypeID
                  : null,
                MealTypeID: accommodation?.MealTypeID
                  ? +accommodation?.MealTypeID
                  : null,
                TotalRoom: accommodation?.TotalRoom
                  ? +accommodation?.TotalRoom
                  : null,
              };
            })
          : [],
        Transportations: result?.Transportations
          ? result?.Transportations?.map((transportation: any) => {
              return {
                VehicleTypeID: transportation?.VehicleTypeID
                  ? +transportation?.VehicleTypeID
                  : null,
                Place: transportation?.Place ? transportation?.Place : "",
                FromDate: transportation?.FromDate
                  ? moment(transportation?.FromDate, "YYYY-MM-DD")?.toDate()
                  : "",
                ToDate: transportation?.ToDate
                  ? moment(transportation?.ToDate, "YYYY-MM-DD")?.toDate()
                  : "",
                Rate: transportation?.Rate ? +transportation?.Rate : null,
              };
            })
          : [],
        Miscellaneous: result?.Miscellaneous
          ? result?.Miscellaneous?.map((miscellaneous: any) => {
              return {
                Title: miscellaneous?.Title ? miscellaneous?.Title : "",
                TotalAmount: miscellaneous?.TotalAmount
                  ? +miscellaneous?.TotalAmount
                  : null,
              };
            })
          : [],
        TourItinerary: result?.Itinary
          ? result?.Itinary?.map((itinerary: any) => {
              return {
                QuotationID: itinerary?.QuotationID
                  ? +itinerary?.QuotationID
                  : null,
                DayNo: itinerary?.DayNo ? +itinerary?.DayNo : null,
                Place: itinerary?.Place ? itinerary?.Place : "",
                ItinaryID: itinerary?.ItinaryID ? +itinerary?.ItinaryID : null,
                Description: itinerary?.Description
                  ? itinerary?.Description
                  : "",
                Facilty: itinerary?.Facilty ? itinerary?.Facilty : "",
              };
            })
          : [],

        Initial: result?.Initial,
        LeadSourceID: result?.LeadSourceID,
        SectorID: result?.SectorID,
        CompanyID: result?.CompanyID,
        Type: result?.Type,
        DiscountAmt: result?.DiscountAmt,
        GstPer: result?.GstPer,
        GstValue: result?.GstValue,
        isTCS: result?.isTCS,
        TCS: result?.TCS,
        FinalAmt: result?.FinalAmt,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
